<script lang="ts">
	interface Props {
		value: unknown;
		name?: string | undefined;
		id?: string | undefined;
		ariaLabel?: string | undefined;
		class?: string;
		children?: import("svelte").Snippet;
		onchange?: (event: Event) => void;
	}

	let {
		value = $bindable(),
		name = undefined,
		id = undefined,
		class: classes = "",
		ariaLabel = undefined,
		children,
		onchange,
	}: Props = $props();
</script>

<select
	class="button text-start pr-3rem border-tundra dark:border-lysning-70 {classes}"
	bind:value
	{name}
	{id}
	{onchange}
	aria-label={ariaLabel}
>
	{@render children?.()}
</select>

<style lang="postcss">
	/* Select button */
	select {
		--icon: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxZW0nIGhlaWdodD0nMWVtJyB2aWV3Qm94PScwIDAgMjU2IDI1Nic+PHBhdGggZmlsbD0nIzAwMjk4NycgZD0nbTIxMy42NiAxMDEuNjZsLTgwIDgwYTggOCAwIDAgMS0xMS4zMiAwbC04MC04MEE4IDggMCAwIDEgNDggODhoMTYwYTggOCAwIDAgMSA1LjY2IDEzLjY2Jy8+PC9zdmc+");
		background:
			no-repeat 100% center / 1rem 1rem var(--icon),
			var(--select-bg, transparent);
		background-position: calc(100% - 1rem) center;
		color: var(--text-color, var(--fg));
	}

	:global([data-theme="dark"] select) {
		--icon: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxZW0nIGhlaWdodD0nMWVtJyB2aWV3Qm94PScwIDAgMjU2IDI1Nic+PHBhdGggZmlsbD0nIzU0OTRmZicgZD0nbTIxMy42NiAxMDEuNjZsLTgwIDgwYTggOCAwIDAgMS0xMS4zMiAwbC04MC04MEE4IDggMCAwIDEgNDggODhoMTYwYTggOCAwIDAgMSA1LjY2IDEzLjY2Jy8+PC9zdmc+");
	}
</style>
